"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactDnd = require("react-dnd");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _underscore = require("underscore");

var _UIDragHandle = _interopRequireDefault(require("UIComponents/draggable/UIDragHandle"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _FormFieldTypes = _interopRequireDefault(require("lead-flows-ui/constants/FormFieldTypes"));

var _DragAndDrop = require("lead-flows-ui/constants/DragAndDrop");

var _Scopes = require("lead-flows-ui/constants/Scopes");

var _Scopes2 = require("lead-flows-ui/selectors/Scopes");

var _FormFieldButton = _interopRequireDefault(require("./FormFieldButton"));

var DEFAULT_FIELD_TYPES = Object.values(_FormFieldTypes.default || {});

var FormField =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormField, _Component);

  function FormField() {
    (0, _classCallCheck2.default)(this, FormField);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormField).apply(this, arguments));
  }

  (0, _createClass2.default)(FormField, [{
    key: "renderButtonPlaceholder",
    value: function renderButtonPlaceholder() {
      return _react.default.createElement(_FormFieldButton.default, {
        icon: "delete",
        style: {
          visibility: 'hidden'
        }
      });
    }
  }, {
    key: "renderEnabledRemoveButton",
    value: function renderEnabledRemoveButton() {
      var name = this.props.name;
      var removeFormField = this.props.removeFormField;
      return _react.default.createElement(_FormFieldButton.default, {
        className: "remove-field-button",
        icon: "delete",
        onClick: function onClick() {
          return removeFormField(name);
        }
      });
    }
  }, {
    key: "renderRemoveButton",
    value: function renderRemoveButton() {
      var name = this.props.name;
      var isDisabled = name === _FormFieldTypes.default.EMAIL;
      return isDisabled ? this.renderButtonPlaceholder() : this.renderEnabledRemoveButton();
    }
  }, {
    key: "renderEditButton",
    value: function renderEditButton() {
      var _this$props = this.props,
          name = _this$props.name,
          editFormField = _this$props.editFormField;
      return _react.default.createElement(_FormFieldButton.default, {
        icon: "edit",
        onClick: function onClick() {
          return editFormField(name);
        }
      });
    }
  }, {
    key: "renderFormField",
    value: function renderFormField(className) {
      var _this$props2 = this.props,
          name = _this$props2.name,
          label = _this$props2.label,
          isFieldAllowed = _this$props2.isFieldAllowed;
      return _react.default.createElement("div", {
        className: className,
        "data-field-name": name
      }, _react.default.createElement(_UIFlex.default, {
        align: "stretch",
        justify: "between",
        direction: "row",
        wrap: "nowrap"
      }, _react.default.createElement(_UIBox.default, {
        grow: 1
      }, _react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, _react.default.createElement(_UIDragHandle.default, {
        className: "fake-input-wrapper"
      }, _react.default.createElement("div", {
        className: "private-form__control p-left-6",
        style: isFieldAllowed ? {} : {
          borderColor: '#f2545b',
          boxShadow: '0 0 0 1px #f2545b'
        }
      }, _react.default.createElement(_UITruncateString.default, null, label))), !isFieldAllowed ? _react.default.createElement("small", {
        className: "private-form__validation is--text--error"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "leadFlowEditor.formFieldEditor.errors.customFieldsSmall"
      })) : null)), _react.default.createElement(_UIBox.default, {
        className: "action-button"
      }, this.renderEditButton()), _react.default.createElement(_UIBox.default, {
        className: "action-button"
      }, this.renderRemoveButton())));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          connectDragSource = _this$props3.connectDragSource,
          isBeingDragged = _this$props3.isBeingDragged;
      var isBeingDraggedClass = isBeingDragged ? 'is-being-dragged' : null;
      var className = (0, _classNames.default)('form-field', isBeingDraggedClass);
      return connectDragSource(this.renderFormField(className));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        name: _react.PropTypes.string.isRequired,
        label: _react.PropTypes.string.isRequired,
        displayOrder: _react.PropTypes.number.isRequired,
        type: _react.PropTypes.string.isRequired,
        fieldType: _react.PropTypes.string.isRequired,
        options: _react.PropTypes.array.isRequired,
        removeFormField: _react.PropTypes.func.isRequired,
        editFormField: _react.PropTypes.func.isRequired,
        connectDragSource: _react.PropTypes.func.isRequired,
        isBeingDragged: _react.PropTypes.bool.isRequired,
        isFieldAllowed: _react.PropTypes.bool.isRequired
      };
    }
  }]);
  return FormField;
}(_react.Component);

var dragSpec = {
  beginDrag: function beginDrag(props) {
    return {
      name: props.name,
      displayOrder: props.displayOrder
    };
  }
};

function collect(connectSource, monitor) {
  return {
    connectDragSource: connectSource.dragSource(),
    isBeingDragged: monitor.isDragging()
  };
}

function mapStateToProps(state, props) {
  var hasCustomFieldsScope = (0, _Scopes2.hasScope)(state, _Scopes.LEAD_FLOWS_CUSTOM_FIELDS_ACCESS);
  var isDefaultProperty = (0, _underscore.contains)(DEFAULT_FIELD_TYPES, props.name);
  return {
    isFieldAllowed: hasCustomFieldsScope || isDefaultProperty
  };
}

var _default = (0, _reactDnd.DragSource)(_DragAndDrop.DragTypes.FORM_FIELD, dragSpec, collect)((0, _reactRedux.connect)(mapStateToProps)(FormField));

exports.default = _default;
module.exports = exports.default;